
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { LeverantorCommandBase } from "./LeverantorCommandBase";

export class ConnectVirkesleverantorCommand extends LeverantorCommandBase {
    andelTaljare: number;
    andelNamnare: number;
    kontaktperson: boolean;
    orgNummer: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ConnectVirkesleverantorCommand";

    constructor(avtalGuid: string, leverantorGuid: string, andelTaljare?: number, andelNamnare?: number, kontaktperson = false, orgNummer?: string) {
        super(avtalGuid, leverantorGuid, ConnectVirkesleverantorCommand.$type, CommandType.Replace);
        this.andelTaljare = andelTaljare;
        this.andelNamnare = andelNamnare;
        this.kontaktperson = kontaktperson;
        this.orgNummer = orgNummer;
    }
}
